exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".travel_info_dialog{width:900px;}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /var/www/html/nissco_event_web/angular/src/app/admin/travel-info-form/travel-info-form.component.css
// module id = ../../../../../src/app/admin/travel-info-form/travel-info-form.component.css
// module chunks = 39